module.exports = __webpack_public_path__ + "static/media/barcelona_getty_desktop.ec99fe30.jpg";